
import { IEmpresas } from "../../interfaces/IEmpresas";

function Exportacao({ empresa }: { empresa: IEmpresas | undefined }) {
    return <>
        {
            <div className="row mt-5">

            </div>
        }
    </>
};

export default Exportacao;